import { useState } from 'react';

/**
 * Custom hook for managing feature and value selection in the editor
 * Handles which feature and value are currently selected
 */
export function useFeatureSelection() {
    // Feature Configuration Editor States
    const [selectedFeatureId, setSelectedFeatureId] = useState(null);
    const [friendlyName, setFriendlyName] = useState('');
    const [description, setDescription] = useState('');
    const [inputType, setInputType] = useState('dropdown');
    const [customAttrs, setCustomAttrs] = useState([]); // [{ key: '', value: '' }]
    const [featureValues, setFeatureValues] = useState([]); // [{ id, value, displayText, description, imageUrl, attributes: [], propertyValues: {} }]
    const [valueSchema, setValueSchema] = useState([]);
    const [cardLayout, setCardLayout] = useState(null);
    const [isSystem, setIsSystem] = useState(false);
    const [isOutput, setIsOutput] = useState(false);
    const [selectedValueId, setSelectedValueId] = useState(null);
    const [savingFeature, setSavingFeature] = useState(false);
    const [featureSearchQuery, setFeatureSearchQuery] = useState('');

    // Feature tree folder expand/collapse state
    const [expandedFolders, setExpandedFolders] = useState({});
    const [expandedFeatures, setExpandedFeatures] = useState({});

    // Inline Feature Rename states
    const [isEditingFeatureName, setIsEditingFeatureName] = useState(false);
    const [editFeatureNameText, setEditFeatureNameText] = useState('');
    const [isSavingFeatureName, setIsSavingFeatureName] = useState(false);

    // Inline Value Rename states
    const [isEditingValueName, setIsEditingValueName] = useState(false);
    const [editValueNameText, setEditValueNameText] = useState('');
    const [isSavingValueName, setIsSavingValueName] = useState(false);

    // Inline Add Feature & Value states
    const [inlineNewValTexts, setInlineNewValTexts] = useState({});
    const [newFeatureInlineName, setNewFeatureInlineName] = useState('');
    const [isAddingFeatureInline, setIsAddingFeatureInline] = useState(false);

    // Add Value states
    const [newValueText, setNewValueText] = useState('');
    const [isAddingValue, setIsAddingValue] = useState(false);

    return {
        selectedFeatureId,
        setSelectedFeatureId,
        friendlyName,
        setFriendlyName,
        description,
        setDescription,
        inputType,
        setInputType,
        customAttrs,
        setCustomAttrs,
        featureValues,
        setFeatureValues,
        valueSchema,
        setValueSchema,
        cardLayout,
        setCardLayout,
        isSystem,
        setIsSystem,
        isOutput,
        setIsOutput,
        selectedValueId,
        setSelectedValueId,
        savingFeature,
        setSavingFeature,
        featureSearchQuery,
        setFeatureSearchQuery,
        expandedFolders,
        setExpandedFolders,
        expandedFeatures,
        setExpandedFeatures,
        isEditingFeatureName,
        setIsEditingFeatureName,
        editFeatureNameText,
        setEditFeatureNameText,
        isSavingFeatureName,
        setIsSavingFeatureName,
        isEditingValueName,
        setIsEditingValueName,
        editValueNameText,
        setEditValueNameText,
        isSavingValueName,
        setIsSavingValueName,
        inlineNewValTexts,
        setInlineNewValTexts,
        newFeatureInlineName,
        setNewFeatureInlineName,
        isAddingFeatureInline,
        setIsAddingFeatureInline,
        newValueText,
        setNewValueText,
        isAddingValue,
        setIsAddingValue
    };
}
